import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import * as DialogActions from '../actions/Dialog';
import * as PasswordActions from '../actions/Password';
import ForgotPasswordCodeForm from '../components/ForgotPasswordCodeForm';

const selector = formValueSelector('forgotPasswordCodeForm');

const mapStateToProps = (state: any) => {
  const username = selector(state, 'username');
  const confirmationCode = selector(state, 'confirmationCode');
  const newPassword = selector(state, 'newPassword');
  const newPasswordCheck = selector(state, 'newPasswordCheck');
  return {
    auth: state.auth,
    initialValues: {
      confirmationCode: state.request_param.search.code
    },
    request_param: state.request_param,
    forgotPasswordCodeForm: {
      username,
      confirmationCode,
      newPassword,
      newPasswordCheck,
    }
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    dialogActions: bindActionCreators(DialogActions, dispatch),
    passwordActions: bindActionCreators(PasswordActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordCodeForm as any);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordCodeForm.tsx